<template>

<div class="form-v2">
  <!-- <v-layout>
		<v-flex>
			<h2>Estatus general de la plataforma</h2>

		<div class="barra_sgp">
			<div>
				<div :style="`width:${75}%`">
					<div>
						<div class="triangle-down" :style="dark_t?'border-top-color:white':''"></div>
					</div>
				</div>
			</div>
			<div>
				<div>
					<div v-for="(v,i) in sgp" :key="i" :style="`background-color:${colors[i]}`"></div>
				</div>
				<div>
					<div v-for="(v,i) in sgp" :key="i">{{v.label}}</div>
				</div>
				<div>
					<div v-for="(v,i) in sgp" :key="i">{{v.value}}</div>
				</div>
			</div>

		</div>
		</v-flex>
  </v-layout> -->
	<div style="text-align:right">
		<!-- <v-btn @click="gauges={}">aaa</v-btn> -->

		<v-btn color="secondary" @click="refresh" :disabled="refreshing">
			<v-icon>refresh</v-icon>
			<span>Recargar</span>
		</v-btn>

	</div>
  <v-layout>
		<doughnut_gauge md="4" :label="`Fiscal year ${current_fiscal_year}`" :value="gauges.fiscal_year"/>
		<doughnut_gauge md="4" label="EBITDA por año fiscal" :value="gauges.ebit"/>
		<doughnut_gauge md="4" label="Engineering Assessment" :value="gauges.ea_file" :l1="(v)=>`${v} EA`"/>
  </v-layout>
  <v-layout>
		<!-- <doughnut_gauge md="4" label="PRT" :value="gauges.prt_file"/> -->
		<doughnut_gauge md="4" label="Estandares" :value="gauges.standard" :l1="(v)=>`${v} STD`"/>
		<doughnut_gauge md="4" label="Política Asset Integrity" :value="gauges.aims_policy"/>
		<doughnut_gauge md="4" label="BCEI" :value="gauges.critical_asset" :l1="(v)=>`${v} BCE&I`"/>
  </v-layout>
  <v-layout>
		<doughnut_gauge md="4" label="CSP" :value="gauges.spare_part" :l1="(v)=>`${v} CSP`"/>
  </v-layout>
</div>
</template>
<script>
import doughnut_gauge from "@/components/outputs/doughnut_gauge.vue";
const count = {total:0,expired:0,current:0,'1mm':0,'3mm':0};

export default {
	components:{doughnut_gauge},
	data(){
		return {
			refreshing:false,
			config_name:'dashboard/status/all',
			gauges: {
				fiscal_year: {count:{...count},status_value:0},
				ebit: {count:{...count},status_value:0},
				prt_file: {count:{...count},status_value:0},
				standard: {count:{...count},status_value:0},
				aims_policy: {count:{...count},status_value:0},
				critical_asset: {count:{...count},status_value:0},
				spare_part: {count:{...count},status_value:0},
			},
			colors:['#CC0031','#DF781E','#E8D243','#7CD054'],
			sgp:[
				{label:'Caducado',value:0},
				{label:'1 mes por vencer',value:0},
				{label:'3 meses por vencer',value:3},
				{label:'Vigente',value:10},
			]
		}
	},
	computed:{
		request_status() { return this.$store.getters.requestStatus },
		my_request_status(){return this.request_status.find(r => r.name == this.config_name)},
		my_request_status_rq() { return this.my_request_status.rq},
		get_rq(){return this.requests.gets[this.config_name]},
		current_fiscal_year(){ return (this.$store.getters.current_fiscal_year ||{}).year },
	},
  watch:{
    'my_request_status_rq'(v){( v.then && v.then(r => this.then_get_rows(r)) )},
  },
	created(){
		this.refresh()
      /* .then(r => this.then_get_rows(r)) */
  }, // created
  methods:{
    reset_rq_status(){
      this.my_request_status.status = false;
      this.my_request_status.ticking = false;
      /* this.myRequestStatus.rq = null; */
    },
    refresh() {
      this.refreshing = true;
			this.reset_rq_status();
      this.get_rq()
        .then(r => (this.refreshing = false) || r);
    },
		then_get_rows(r) {this.gauges = r}
	}
};
</script>

<style scoped>
.form-v2 .flex{
	box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
	margin: 10px;
	padding: 15px;
}
.barra_sgp>div:nth-of-type(1)>div{
	text-align: right;
	height: 40px;
}
.barra_sgp>div:nth-of-type(1)>div>div{
	display: inline-block;
	height: 0;
	width: 0;
	vertical-align: middle;
}
.barra_sgp>div:nth-of-type(1)>div>div>i{
	right: 25px;
	position: relative;
	font-size: 50px;
	width: 50px;
}
.barra_sgp>div:nth-of-type(2){
	margin: auto;
}
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(1){
	height: 30px;
	width: 100%;
}
.barra_sgp>div:nth-of-type(2)>div>div{
	display: inline-block;
	width: 25%;
	height: 100%;
	text-align: center;
}
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(2),
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(3){
	padding: 5px;
	font-weight: bold;
}
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(2){
	font-size: 15px;
}
.barra_sgp>div:nth-of-type(2)>div:nth-of-type(3){
	font-size: 30px;
	color: coral;
}
.triangle-down {
	width: 0;
	height: 0;
	border-left: 20px solid transparent;
	border-right: 20px solid transparent;
	border-top: 28px solid;
	border-top-color:black;
	right: 20px;
	position: relative;
}
</style>